import { render, staticRenderFns } from "./CommercialOfferDispatches.vue?vue&type=template&id=3d18b6fd&scoped=true"
import script from "./CommercialOfferDispatches.vue?vue&type=script&lang=js"
export * from "./CommercialOfferDispatches.vue?vue&type=script&lang=js"
import style0 from "./CommercialOfferDispatches.vue?vue&type=style&index=0&id=3d18b6fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d18b6fd",
  null
  
)

export default component.exports